import React, { RefObject, useEffect, useRef, useState } from 'react';

import { AxiosError } from 'axios';
import toast from 'react-hot-toast';
import { RegisterCubageHandle } from '../../../components/RegisterCubage/RegisterCubage';
import { ICubage } from '../../../interfaces/response/Cubage/ICubage';
import { ObterCubagens } from '../../../redux/features/cubages/cubagesThunk';
import { useAsyncDispatch } from '../../../redux/store';

export interface IProps {
  cubages: ICubage[];
  setFilter: React.Dispatch<React.SetStateAction<string>>;
  loading: boolean;
  handleGetCubages: () => void;
  modalRef: RefObject<RegisterCubageHandle>;
}

const useCubage = (): IProps => {
  const [filter, setFilter] = useState<string>('');
  const modalRef = useRef<RegisterCubageHandle>(null);
  const dispatch = useAsyncDispatch();
  const [sortedCubages, setSortedCubages] = useState<ICubage[]>([]);
  const [cubages, setCubages] = useState<ICubage[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const sortedArray = sortedCubages.filter((cubage) =>
      cubage.ean.toLowerCase().includes(filter.toLowerCase())
    );
    setSortedCubages(sortedArray);
  }, [filter]);

  const consultarCubagens = async (): Promise<void> => {
    setLoading(true);

    await dispatch(ObterCubagens())
      .unwrap()
      .then(async (response) => {
        setCubages(response.cubagens);
        setSortedCubages(response.cubagens);
      })
      .catch((error) => {
        const axiosError = error as AxiosError;
        if (axiosError.code === 'ERR_CANCELED') return;

        toast.error(
          'Erro ao consultar tabelas preço, por favor tente mais tarde'
        );
      })
      .finally(() => setLoading(false));
  };

  const handleGetCubages = (): void => {
    consultarCubagens();
  };

  useEffect(() => {
    consultarCubagens();
  }, []);

  return {
    cubages: sortedCubages,
    setFilter,
    loading,
    handleGetCubages,
    modalRef,
  };
};

export default useCubage;
